export const formatCardBadge = (monthlyTier: number, months: number = 12): string => {
  return `₪${monthlyTier.toLocaleString('he-IL')} × ${months}`
}

export const formatTotalRaised = (total: number): string => {
  return new Intl.NumberFormat('he-IL', {
    style: 'currency',
    currency: 'ILS',
    maximumFractionDigits: 0,
  }).format(total)
}

export const formatDonorName = (name: string): string => {
  return name?.trim() || 'החפץ בעילום שמו'
}
